<script setup lang="ts">
// EAUG-77: an edit link (?mode=edit&token=…) opens the order-edit page
// instead of the wizard. Decided once from this iframe's own URL (the
// WordPress page forwards its whole query string), before any wizard store
// exists: building them already reads, cleans and rewrites the visitor's own
// cart (booking_* keys) and arms the date watcher. The edit page must leave
// that cart exactly as it was, so it never builds them.
import BookingWizard from './booking-wizard.vue';
import OrderEdit from '@/components/order-edit/order-edit.vue';
import { readEditEntry } from '@/services/orderEditUrl';

const editEntry = readEditEntry(window.location.search);
</script>

<template>
  <order-edit v-if="editEntry" :token="editEntry.token" :paid-id="editEntry.paidId" />
  <booking-wizard v-else />
</template>
